import { RunningExperiments, useExperiments } from 'state/experiments';
import LocalStorage, { StorageKeys } from 'utils/local-storage';

// FIXME: Remove after completing the experiment
export const isSelectPickerMediumSizeAsDefaultEnabled = () => {
  const variants = LocalStorage.getItem(StorageKeys.AMPLITUDE_VARIANTS) || {};
  const foundVariant = variants[RunningExperiments.SelectPickerMediumSizeAsDefault];
  return foundVariant?.value === 'treatment';
};

export const useLogExposureToSelectPickerMediumSizeAsDefaultExperiment = () => {
  const { logExposure } = useExperiments();

  return logExposure(RunningExperiments.SelectPickerMediumSizeAsDefault);
};
